import React from 'react';
import BaseDrawingMaterialChooser from 'components/quote_builder_widget/shared/BaseDrawingMaterialChooser';
import styles from './_style.module.scss';

const DrawingMaterialChooser = ({ widgetIdentifier, drawingId, onMaterialChange, onCartonMaterialSelected }) => {
  return (
    <BaseDrawingMaterialChooser
      widgetIdentifier={widgetIdentifier}
      drawingId={drawingId}
      onMaterialChange={onMaterialChange}
      onCartonMaterialSelected={onCartonMaterialSelected}
      styles={styles}
      selectClassName={`${styles.input} ${styles.inputWithoutSuffix}`}
    />
  );
};

export default DrawingMaterialChooser;
